import { createClient } from '@connectrpc/connect';
import { PcfBundledSettingsService } from './gen/pcf_bundled_settings_service_pb';
import { getGrpcTransport } from './transport';
import { useIntegrationDiagnosticsStore } from '../../stores/useIntegrationDiagnosticsStore';
import type { PcfSettingsDto } from './gen/pcf_export_service_pb';

function getClient() {
  const transport = getGrpcTransport();
  if (!transport) {
    return null;
  }

  return createClient(PcfBundledSettingsService, transport);
}

export async function readBundledPcfConfigGrpc(): Promise<{
  success: boolean;
  settings?: PcfSettingsDto;
  error?: string;
}> {
  const client = getClient();
  if (!client) {
    useIntegrationDiagnosticsStore.getState().setLastGrpcError('ReadBundledPcfConfig: gRPC transport is unavailable');
    return { success: false, error: 'gRPC transport is unavailable' };
  }

  try {
    const response = await client.readBundledPcfConfig({});
    if (response.isSuccess) {
      useIntegrationDiagnosticsStore.getState().setLastGrpcError(null);
    } else if (response.error) {
      useIntegrationDiagnosticsStore.getState().setLastGrpcError(`ReadBundledPcfConfig: ${response.error}`);
    }
    return {
      success: response.isSuccess,
      settings: response.settings ?? undefined,
      error: response.error || undefined,
    };
  } catch (error) {
    const message = error instanceof Error ? error.message : 'ReadBundledPcfConfig gRPC error';
    useIntegrationDiagnosticsStore.getState().setLastGrpcError(`ReadBundledPcfConfig: ${message}`);
    return { success: false, error: message };
  }
}
